import { connect } from 'react-redux';

import ReviewForm from './ReviewForm.js';
// import { redux as apiRedux } from '../api';
import { redux } from '../api';
const { setApplicationInfo, setCurrentSearchInfo } = redux.actions;

const mapStateToProps = state => {
  return {
    userInfo: state.api.user.info,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setApplicationData: data => dispatch(setApplicationInfo(data)),
    setCurrentSearchInfoData: data => dispatch(setCurrentSearchInfo(data)),
  };
};

const ConnectedReviewForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReviewForm);

export default ConnectedReviewForm;
